import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NotebookIcon from "@/fragments/NotebookIcon";
import { ScheduleSend } from "@mui/icons-material";

export default function PostTabs() {
  const [tab, setTab] = useState(0);
  const navigate = useNavigate();

  const handleTabChange = (e, newValue) => {
    switch (newValue) {
      case 0:
        navigate(`/post`);
        break;
      case 1:
        navigate(`/scheduled`);
        break;
    }
  };

  useEffect(() => {
    if (window.location.pathname === `/post`) {
      setTab(0);
    } else if (window.location.pathname === `/scheduled`) {
      setTab(1);
    }
  }, [window.location.pathname]);

  return (
    <>
      {/* Mobile bottom tabs */}
      <Box sx={{ display: { xs: "block", lg: "none" } }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="secondary"
          variant="fullWidth"
          slotProps={{
            indicator: {
              sx: { top: 0 },
            },
          }}
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            bgcolor: "rgba(36, 36, 36, 0.95)",
            pt: 0,
            pb: 2,
            "& .MuiTab-root": {
              minWidth: "70px",
              height: "80px",
            },
          }}
        >
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <NotebookIcon size={24} />
              </Box>
            }
            label="New"
            iconPosition="start"
          />
          <Tab icon={<ScheduleSend />} label="Scheduled" iconPosition="start" />
        </Tabs>
      </Box>

      {/* Desktop side tabs */}
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          orientation="vertical"
          variant="fullWidth"
          TabIndicatorProps={{ sx: { left: 0 } }}
          sx={{
            position: "fixed",
            left: 20,
            top: "25%",
            transform: "translateY(-50%)",
            bgcolor: "rgba(18, 18, 18, 0.95)",
            width: "140px",
            "& .MuiTab-root": {
              minHeight: "70px",
              width: "100%",
              padding: "15px",
              justifyContent: "flex-start",
              gap: 1,
            },
          }}
        >
          <Tab
            icon={
              <Box sx={{ display: "flex", alignItems: "center", pr: 0.3 }}>
                <NotebookIcon size={24} />
              </Box>
            }
            label="New"
            iconPosition="start"
          />
          <Tab icon={<ScheduleSend />} label="Scheduled" iconPosition="start" />
        </Tabs>
      </Box>
    </>
  );
}
